import React from "react";
import Secondary from "@ui/Header/Secondary";
import SidePanelLayout from "@ui/SidePanel/Layout";
import { ClassificationNavigation } from "./Navigation";
import { Navigate, Outlet, useLocation } from "react-router";

export function Classification() {
  const location = useLocation();

  if (location.pathname === "/administration/classification")
    return <Navigate to="/administration/classification/quantities" replace />;

  return (
    <>
      <Secondary nav={<ClassificationNavigation />} />
      <SidePanelLayout>
        <Outlet />
      </SidePanelLayout>
    </>
  );
}
